import { get_price_request } from '/srv/web/wyvr/html/releases/58819/gen/client/price_request/get_price_request.js?1733898722666';
import { get_domain } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/api-client/get_domain.js?1733898722666';
import { get_store } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/api-client/get_store.js?1733898722666';
import { get_attribute_value, get_attribute_name } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/attributes.js?1733898722666';
import { url_join } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/url.js?1733898722666';
import { context } from '/srv/web/wyvr/html/releases/58819/gen/client/wyvr/context.js?1733898722666';

export async function process_ga4_item(product, qty, load_categories = true) {
    if (!product) {
        return undefined;
    }
    const sku = get_attribute_value(product, 'sku');

    const item = {
        item_id: sku,
        item_name: get_attribute_value(product, 'name'),
        price: get_price_request(product) ? undefined : get_attribute_value(product, 'final_price') || get_attribute_value(product, 'price'),
        quantity: qty,
        currency: getStack('currency')
    };
    // get brand
    const brand = get_attribute_name(product, 'pim_brand');
    if (brand) {
        item.item_brand = brand;
    }
    // only add variants to simple products
    if (product.type_id === 'simple') {
        const variant = [get_attribute_name(product, 'kw_main_color'), get_attribute_name(product, 'kw_sizeindex'), get_attribute_name(product, 'kw_sizeindex_shoes')]
            .filter(Boolean)
            .join(',');
        if (variant) {
            item.item_variant = variant;
        }
    }
    if (load_categories) {
        try {
            // add categories to item
            await append_ga4_item_categories(item, get_attribute_value(product, 'category_ids'));
        } catch (e) {
            console.error(e);
        }
    }

    return item;
}

export async function append_ga4_item_categories(item, category_ids, domain_url, store_key) {
    const categories = await load_categories(category_ids, domain_url, store_key, 5);
    if (categories) {
        append_loaded_categories_to_ga4_item(item, categories);
    }
}

export async function load_categories(category_ids, domain_url, store_key, limit) {
    if (!Array.isArray(category_ids) || category_ids.length === 0) {
        return [];
    }
    const store = get_store(store_key);
    const domain = get_domain(domain_url);
    const data = {
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'get'
    };
    if (!context().gtm_cache_category) {
        context().gtm_cache_category = new Map();
    }
    // load the categories
    const result = [];
    const load_category_ids = [];
    for (const id of category_ids) {
        if (context().gtm_cache_category.has(id)) {
            result.push(context().gtm_cache_category.get(id));
            continue;
        }
        load_category_ids.push(id);
    }

    const limit_param = limit ? `&limit=${limit}` : '';
    if (load_category_ids.length > 0) {
        try {
            const url = url_join(domain, store, 'api', 'category', 'get');
            const response = await fetch(`${url}?ids=${load_category_ids.join(',')}${limit_param}`, data);
            if (response.ok && response.body) {
                const categories = await response.json();
                for (const category of categories) {
                    if (category?.entity_id) {
                        context().gtm_cache_category.set(category.entity_id, category);
                    }
                    result.push(category);
                }
            }
        } catch (e) {
            console.error(e);
            return [];
        }
    }
    return result;
}

export function append_loaded_categories_to_ga4_item(item, categories) {
    let number = 1;
    for (const category of categories.slice(0, 5)) {
        if (category.name) {
            item[`item_category${number === 1 ? '' : number}`] = category.name;
            number++;
        }
    }
}

export function get_value_of_items(items) {
    if (!Array.isArray(items) || items.length === 0) {
        return undefined;
    }
    return items.reduce((acc, item) => {
        if (item?.price && item?.quantity) {
            return acc + item.price * item.quantity;
        }
        return acc;
    }, 0);
}
